import {Box, Flex, propNames, Spacer} from '@chakra-ui/react';
import React from 'react';
import {DepartmentSelect} from '../../../Department/DepartmentSelect';
import FlexCard from '../../../General/FlexCard';
import {CustomCheckbox, CustomInput, DatePicker} from '../../../General/FormInputs';

const EmployeeInfo = ({register, errors, control}) => {
  return (
    <FlexCard mr="2" w="100%">
      <Box>
        <Flex>
          <Box>
            <Flex>
              <CustomInput register={register} id="emCode" name="Code" errors={errors} isReadOnly={true} w="30%" />
              <CustomInput
                register={register}
                id="emName"
                name="Employee name"
                // isReadOnly={employee ? false : true}
                errors={errors}
                w="70%"
              />
            </Flex>
            <DepartmentSelect control={control} name={'emDept'} />
            <CustomInput
              register={register}
              id="emTitle"
              name="Title"
              errors={errors}
              // isReadOnly={employee ? false : true}
            />
            <CustomInput
              register={register}
              id="emOppname"
              name="Opp Plan SS Name"
              errors={errors}
              // isReadOnly={employee ? false : true}
            />
          </Box>
          <Spacer />
          <Box>
            <CustomInput
              register={register}
              id="clRep"
              name="Account Rep"
              errors={errors}
              // isReadOnly={employee ? false : true}
            />
            <Flex>
              <DatePicker
                register={register}
                id="emAdate"
                // value={date}
                // onChange={fixChecks}
                name="Date Added"
                errors={errors}
                required
                // isReadOnly={employee ? false : true}
              />
              <DatePicker
                register={register}
                id="emTdate"
                // value={date}
                // onChange={fixChecks}
                name="Date Terminated"
                errors={errors}

                // isReadOnly={employee ? false : true}
              />
            </Flex>
            <CustomInput
              id="emSalary"
              requireInt={true}
              type="number"
              // isReadOnly={employee ? false : true}
              name="Salary"
              register={register}
              errors={errors}
              required
            />
          </Box>

          <Box textAlign="start" mt="1" ml="3">
            <CustomCheckbox
              control={control}
              // isChecked={employee?.loInact}
              // defaultChecked={employee?.loInact ? 1 : 0}
              // onChange={e => setEmployee(loc => ({...loc, loInact: e.target.checked}))}
              id="emInact"
              name="Inactive"
              mt="3"
              // isReadOnly={employee ? false : true}
            />
            <CustomCheckbox
              control={control}
              // isChecked={employee?.loInact}
              // defaultChecked={employee?.loInact ? 1 : 0}
              // onChange={e => setEmployee(loc => ({...loc, loInact: e.target.checked}))}
              id="emDefault"
              name="Use as Default"
              mt="3"
              // isReadOnly={employee ? false : true}
            />
          </Box>
        </Flex>
      </Box>
    </FlexCard>
  );
};

export default EmployeeInfo;
